<template>
  <div class="page-news" :class="'hide-bread'">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`/feature-gslc/ss/society`">社会服务</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/feature-gslc/ss/support`">技术支持</el-breadcrumb-item>
        <el-breadcrumb-item>在线FAQ</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content news-content">
        <column-header2 :data="{ name: '在线FAQ' }"></column-header2>
        <ic-news :data="FQAList"></ic-news>
        <el-pagination v-if="total > pageSize" class="g-pagination" :current-page="pageIndex" :page-size="pageSize" layout="prev, pager, next" :total="total" background @current-change="handleIndexChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnHeader from "_c/ColumnHeader2";
import News from "_c/News";
import { getData } from "api/app";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      FQAList: [],
      total: 0,
      pageSize: 2,
      pageIndex: 1
    };
  },
  components: {
    [News.name]: News,
    [ColumnHeader.name]: ColumnHeader
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  created() {
    this.loadData();
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },

    loadData() {
      this.loading = true;
      // let params = [
      //   { Key: "College", Value: this.collegeData.cid, CompareType: "EqualTo" }
      // ];
      let params = [
        {
          Key: "College",
          Value: this.$store.getters.cid,
          CompareType: "EqualTo"
        }
      ];
      var queryParams = {
        name: "FAQ",
        index: this.pageIndex,
        size: this.pageSize ?? 10,
        params
      };
      getData(queryParams)
        .then(res => {
          this.FQAList = res.Data.map(item => {
            return {
              Headline: item.Question,
              Summary: item.Answer,
              link: "faq/detail/" + item.Id
            };
          });
          this.total = res.TotalCount;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-news {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-news,
  ::v-deep .comp-download {
    padding: 5px 0 20px 0;
  }
  ::v-deep .comp-download li {
    padding: 0;
  }
  ::v-deep .comp-news--calendar {
    li {
      border-bottom: 0;
      padding: 0 0 24px 93px;
      height: 70px;
    }
    h3 {
      font-size: 20px;
      line-height: 28px;
      padding: 8px 0 4px 0;
    }
    p {
      font-size: 14px;
      line-height: 18px;
    }
    a {
      .date {
        width: 77px;
        height: 70px;
        top: 0;
        strong {
          margin-top: 12px;
          margin-bottom: 4px;
        }
      }
    }
  }
  .news-content {
    padding-bottom: 40px;
    ::v-deep .comp-column-header {
      padding: 0 0 16px 0;
    }
  }
}
</style>
